import React, { useEffect, useRef, useState } from "react";

import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";

import { isNullOrUndefinedOrEmpty } from "../../utils/Utils";

import "./WPAgGrid.scss";

const WPAGridCellRender = (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const displayCellValue = isNullOrUndefinedOrEmpty(cellValue)
    ? "-"
    : cellValue;
  const cellRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (cellRef.current) {
      setIsOverflowing(
        cellRef.current.scrollWidth > cellRef.current.clientWidth,
      );
    }
  }, [displayCellValue]);

  return (
    <CustomTooltip text={isOverflowing ? displayCellValue : ""} placement="top">
      <div ref={cellRef} className="ag-tooltip-container">
        {displayCellValue}
      </div>
    </CustomTooltip>
  );
};

export default WPAGridCellRender;
